const t = {
  name: "Weight",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2C9.78771 2 8 3.78772 8 6C8 6.72903 8.19414 7.41196 8.53363 8H6.27924L4 14.8377V22H20V14.8377L17.7208 8H15.4664C15.8059 7.41196 16 6.72903 16 6C16 3.78772 14.2123 2 12 2ZM12 8C10.8923 8 10 7.10772 10 6C10 4.89228 10.8923 4 12 4C13.1077 4 14 4.89228 14 6C14 7.10772 13.1077 8 12 8ZM7.72076 10H16.2792L18 15.1623V20H6V15.1623L7.72076 10Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Weight
};
